import { faClock } from '@fortawesome/pro-light-svg-icons/faClock';
import { Property } from '@propertypal/shared/src/types/property';
import puralise from '@propertypal/shared/src/utils/puralise';
import React, { CSSProperties } from 'react';
import { useTheme } from 'styled-components';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { BadgeText, Container, Placeholder, Row } from './PropertyBadge.style';

interface Props {
  property: Property;
  containerStyle?: CSSProperties;
  useWideDisplay?: boolean;
  hideBadge?: boolean;
  disablePlaceholder?: boolean;
  showStatusBadge?: boolean;
}

const PropertyBadge = (props: Props) => {
  const { listingTime, totalAvailableUnits, phases } = props.property;
  const theme = useTheme();
  const isStudent = props.property.style?.key === 'studentApartment';
  const hasListingTime = !!(listingTime && listingTime.typeText && listingTime.timeText && listingTime.type);
  const cashSale = props.property.cashSaleOnly || props.property.price?.priceType === 'CASH_OFFERS_ONLY';

  if (!props.hideBadge) {
    if (totalAvailableUnits !== undefined && totalAvailableUnits > 0 && props.property.saleType.key !== 'rent') {
      return (
        <Row style={props.containerStyle}>
          <Container className="pp-property-box-badge" $backgroundColor={theme.textDark}>
            <BadgeText data-testid="badgeText">
              {`${totalAvailableUnits} ${puralise('home', 'homes', totalAvailableUnits)} available`}
            </BadgeText>
          </Container>
          {phases &&
            !!phases.length &&
            phases.map((p) => (
              <Container key={p.id} $backgroundColor={theme.textDark}>
                <BadgeText data-testid="phasesBadgeText">{p.name}</BadgeText>
              </Container>
            ))}
        </Row>
      );
    }

    if (hasListingTime || isStudent || cashSale) {
      return (
        <Row style={props.containerStyle}>
          {props.showStatusBadge && props.property.status && (
            <Container $backgroundColor={theme.primary}>
              <BadgeText>{props.property.status.text}</BadgeText>
            </Container>
          )}

          {cashSale && (
            <Container $backgroundColor={theme.primary}>
              <BadgeText>Cash Offers Only</BadgeText>
            </Container>
          )}

          {hasListingTime && (
            <Container className="pp-property-box-badge" $backgroundColor={theme.textDark}>
              <BadgeText data-testid="badgeText">
                {listingTime.type === 'auction' && (
                  <FontAwesomeIcon icon={faClock} color={theme.white} style={{ margin: '0 4px -2px 0' }} />
                )}
                {listingTime.typeText} {listingTime.timeText}
              </BadgeText>
            </Container>
          )}

          {isStudent && (
            <Container className="pp-property-box-badge" $backgroundColor={theme.primary}>
              <BadgeText data-testid="badgeText">Student Rental</BadgeText>
            </Container>
          )}
        </Row>
      );
    }
  }

  if (props.disablePlaceholder) return null;

  return <Placeholder $useWideDisplay={props.useWideDisplay} />;
};

export default PropertyBadge;
